import Component from '../lib/component';
import Counter from './counter';
import Fan from './fan';
import WheelSize from './wheel-size';
// Import constants
import { MAX_SPEED, MIN_SPEED, SPEED_UNIT, SPEED_STEPS, MAX_TEMP, MIN_TEMP, TEMP_UNIT, TEMP_STEPS, AC_HEAT_LIMIT } from '../constants';

class Inputs extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props };
    // Create a new instance of counter component as speed counter
    this.speedCounterComponent = new Counter({
      parent: this,
      watchers: { value: 'speed' },
      data: {
        componentName: 'speed-counter',
        value: this.state.data.speed,
        unit: SPEED_UNIT,
        unitIsDegree: false,
        min: MIN_SPEED,
        max: MAX_SPEED,
        steps: SPEED_STEPS,
      },
    });
    // Create a new instance of counter component as temperature counter
    this.temperatureCounterComponent = new Counter({
      parent: this,
      watchers: { value: 'temp' },
      data: {
        componentName: 'temperature-counter',
        value: this.state.data.temp,
        unit: TEMP_UNIT,
        unitIsDegree: true,
        min: MIN_TEMP,
        max: MAX_TEMP,
        steps: TEMP_STEPS,
      },
    });
    // Create a new instance of fan component
    this.temperatureFanComponent = new Fan({
      parent: this,
      watchers: { status: 'fan' },
      data: {
        componentName: 'temperature-fan',
        status: this.state.data.fan,
        temp: this.state.data.temp,
        limit: AC_HEAT_LIMIT,
      },
    });
    // Create a new instance of wheel size component
    this.wheelSizeComponent = new WheelSize({
      parent: this,
      watchers: { value: 'wheelSize' },
      data: {
        componentName: 'wheel-size',
        value: this.state.data.wheelSize,
        sizes: [19, 21],
      },
    });
  }

  // Update props when each of its that specified in the watchers in each child components were changed
  emit(props) {
    Object.keys(props).forEach((key) => {
      if (props[key] !== null && props[key] !== undefined) {
        this.setState({ [key]: props[key] });

        // If speed prop value is changed then update wheels rotation speed
        if (key === 'speed') {
          const wheels = Array.prototype.slice.call(document.querySelectorAll('.rpc-section__wheel'), 0);
          wheels.forEach((wheel) => {
            wheel.setAttribute('data-speed', props[key]);
          });
        }
        // If temp prop value is changed then update fan temp prop that will be used to change ac/heat state
        if (key === 'temp') {
          this.temperatureFanComponent.setState({ [key]: props[key] });
        }
      }
    });
  }

  // Define the template elements
  template() {
    this.temp = `
        <!-- Inputs - speed -->
        <div class="rpc-section__input rpc-section__input--speed">
          <div class="rpc-section__input-container">
            <!-- Speed - label -->
            <label class="rpc-section__input-label">Speed</label>
            <!-- Speed - counter -->
            ${this.speedCounterComponent.render()}
          </div>
        </div>
        <!-- Inputs - outside temperature -->
        <div class="rpc-section__input rpc-section__input--temperature">
          <div class="rpc-section__input-container">
            <!-- Outside temperature - label -->
            <label class="rpc-section__input-label">Outside temperature</label>
            <!-- Outside temperature - counter -->
            ${this.temperatureCounterComponent.render()}
          </div>
          <!-- Outside temperature - fan -->
          ${this.temperatureFanComponent.render()}
        </div>
        <!-- Inputs - wheels -->
        <div class="rpc-section__input rpc-section__input--wheels">
          <div class="rpc-section__input-container">
            <!-- Wheels - label -->
            <label class="rpc-section__input-label">Wheels</label>
            <!-- Wheels - wheel size -->
            <div class="rpc-section__wheel-size">
              ${this.wheelSizeComponent.render()}
            </div>
          </div>
        </div>
      `;

    return this.temp;
  }
}

export default Inputs;
